import { GoUnmute, GoMute } from 'react-icons/go';
import { useSquashMuteStore } from '@src/data/-squashStore.js';
import { HStack } from 'ui_2';

export const MuteButton = () => {
  const [isMuted, setIsMuted] = useSquashMuteStore((state) => [
    state.muted,
    state.setMuted,
  ]);

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  return (
    <HStack
      className='right-0 z-50 h-[35px] w-[35px] cursor-pointer rounded-full border border-gray-100 bg-gray-50 p-2 transition-colors duration-300 hover:bg-white active:bg-gray-200'
      onClick={toggleMute}
    >
      {isMuted ? (
        <GoMute className='text-black' />
      ) : (
        <GoUnmute className='text-black' />
      )}
    </HStack>
  );
};
